import { render, staticRenderFns } from "./StudentInformationStatus.vue?vue&type=template&id=7a44fa7e&scoped=true&lang=pug&"
import script from "./StudentInformationStatus.vue?vue&type=script&lang=ts&"
export * from "./StudentInformationStatus.vue?vue&type=script&lang=ts&"
import style0 from "./StudentInformationStatus.vue?vue&type=style&index=0&id=7a44fa7e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a44fa7e",
  null
  
)

export default component.exports